var render = function render(){var _vm=this,_c=_vm._self._c;return _c('a',{staticClass:"burger",class:{ 'is-open': _vm.isOpen },attrs:{"href":"#"},on:{"click":function($event){$event.preventDefault();return _vm.toggleMe.apply(null, arguments)}}},[_c('div',{staticClass:"burger__bar"}),_c('div',{staticClass:"burger__bar"})])
}
var staticRenderFns = []

export { render, staticRenderFns }